export enum ResourceTypeDetailEnum {
  ABOUT_START = 50,
  ARN_SURVEY_BUTTON_TEXT = 215,
  ARN_SURVEY_DESCRIPTION = 214,
  ARN_SURVEY_END_DATE = 218,
  ARN_SURVEY_END_TEXT = 216,
  ARN_SURVEY_ID = 213,
  ARN_SURVEY_START_DATE = 217,
  BEAUTY_GUIDE_BUTTON_LABEL = 219,
  BEAUTY_GUIDE_DESCRIPTION = 220,
  BEAUTY_GUIDE_IMAGE = 221,
  CANCELED = 15,
  CAPACITY = 20,
  CHALLENGE_MATERIALS_DESCRIPTION = 80,
  CHALLENGE_VISIBILITY_END_DATE = 156,
  CHECKOUT_ADDRESS_TYPE = 98,
  CHECKOUT_BOOKING_TIMIFY_BUTTON_TEXT = 248,
  CHECKOUT_BOOKING_TIMIFY_ID = 250,
  CHECKOUT_BOOKING_TIMIFY_TEXT = 249,
  CHECKOUT_PAYMENT_DESCRIPTION = 267,
  CHECKOUT_PAYMENT_QUESTION = 268,
  CHECKOUT_PAYMENT_BUTTON_NAME = 269,
  CHECKOUT_PAYMENT_COMPLETED_LABEL = 270,
  CHECKOUT_PAYMENT_MAIL = 271,
  CHECKOUT_PAYMENT_MAIL_SAP = 272,
  CHECKOUT_PAYMENT_TERMS = 273,
  CHECKOUT_PAYMENT_TERMS_LABEL = 274,
  CHECKOUT_PAYMENT_PRODUCT_IMAGE = 275,
  CHECKOUT_PAYMENT_PRODUCT_PRICE = 276,
  CHECKOUT_PAYMENT_PRODUCT_POINTS = 277,
  CHECKOUT_PAYMENT_PRODUCT_EAN = 278,
  CHECKOUT_PAYMENT_PRODUCT_TYPE = 279,
  CHECKOUT_PAYMENT_PRODUCT_ORIGINAL_STOCK = 280,
  CHECKOUT_PAYMENT_PRODUCT_CURRENT_STOCK = 281,
  CHECKOUT_BUTTON_NAME = 99,
  CHECKOUT_COMPLETED_LABEL = 100,
  CHECKOUT_DESCRIPTION = 96,
  CHECKOUT_DONATION_BUTTON_LEVEL = 230,
  CHECKOUT_DONATION_CARD_DESCRIPTION = 232,
  CHECKOUT_DONATION_IMAGE = 229,
  CHECKOUT_DONATION_NAME = 228,
  CHECKOUT_DONATION_PRODUCT = 235,
  CHECKOUT_DONATION_QUESTION_SELECT = 231,
  CHECKOUT_DONATION_TERMS_DOCUMENT = 234,
  CHECKOUT_DONATION_TERMS_LABEL = 233,
  CHECKOUT_DONE_USER_SHIPPING_MAIL = 166,
  CHECKOUT_END_MESSAGE = 155,
  CHECKOUT_IMAGE_DESKTOP = 142,
  CHECKOUT_IMAGE_MOBILE = 141,
  CHECKOUT_LOTTERY_BUTTON_NAME = 208,
  CHECKOUT_LOTTERY_IMAGE = 211,
  CHECKOUT_LOTTERY_ORDER_DESCRIPTION = 253,
  CHECKOUT_LOTTERY_ORDER_TITLE = 252,
  CHECKOUT_LOTTERY_SHOW_ORDER = 254,
  CHECKOUT_LOTTERY_STICKY_TEXT = 251,
  CHECKOUT_LOTTERY_SUCCESS_WYSWYG = 255,
  CHECKOUT_LOTTERY_TERMS_DOCUMENT = 209,
  CHECKOUT_LOTTERY_TERMS_LABEL = 210,
  CHECKOUT_LOTTERY_TEXT = 212,
  CHECKOUT_MAIL = 107,
  CHECKOUT_PRODUCT_CURRENT_STOCK = 104,
  CHECKOUT_PRODUCT_EAN = 101,
  CHECKOUT_PRODUCT_IMAGE = 102,
  CHECKOUT_PRODUCT_ITEM_DESCRIPTION = 171,
  CHECKOUT_PRODUCT_ORIGINAL_STOCK = 103,
  CHECKOUT_PRODUCT_TYPE = 177,
  CHECKOUT_QUESTION = 97,
  CHECKOUT_SAP_MAIL = 108,
  CHECKOUT_SHIPPING_TYPE_QUESTION = 168,
  CHECKOUT_TERMS_LABEL = 170,
  CHECKOUT_TERMS_URL = 169,
  CHECKOUT_USER_SHIPPING_MAIL = 151,
  CITY = 21,
  CODE = 19,
  CONTINUE = 9,
  CORRECT = 13,
  EMAIL_WITH_DATE_DATE = 193,
  EMAIL_WITH_DATE_ID_MAIL = 192,
  EMAIL_WITH_DELAY_DAY = 182,
  EMAIL_WITH_DELAY_HOUR = 181,
  EMAIL_WITH_DELAY_ID_MAIL = 180,
  ENABLED = 14,
  EVENT_CONTENT = 25,
  EVENT_END = 41,
  EVENT_START = 24,
  EXPERIENCE_ACTIVATION_BUTTON = 114,
  EXPERIENCE_ACTIVATION_DESCRIPTION = 113,
  EXPERIENCE_ACTIVATION_LINK_TITLE = 115,
  EXPERIENCE_ACTIVATION_LINK_URL = 116,
  EXPERIENCE_ACTIVATION_MODAL_BUTTON = 118,
  EXPERIENCE_ACTIVATION_MODAL_DESCRIPTION = 117,
  EXPERIENCE_PROGRESS_FULL = 89,
  EXPERIENCE_PROGRESS_HALF = 88,
  EXPERIENCE_PROGRESS_NONE = 87,
  FORMATION_CERTIFICATE_TEMPLATE = 245,
  FORMATION_CERTIFICATE_REQUIRED_POINTS = 246,
  FAQ_1_CONTENT = 29,
  FAQ_2_CONTENT = 30,
  FAQ_3_CONTENT = 31,
  FAQ_4_CONTENT = 32,
  FAQ_5_CONTENT = 33,
  FULL = 18,
  GALLERY_IMAGE_URL = 34,
  GALLERY_VIDEO_URL = 35,
  GENERIC_BUTTON_DESCRIPTION = 206,
  GENERIC_BUTTON_LABEL_COMPLETED = 185,
  GENERIC_BUTTON_MODAL_DESCRIPTION = 188,
  GENERIC_BUTTON_MODAL_TITLE = 187,
  GENERIC_BUTTON_SHOW_MODAL = 186,
  GENERIC_BUTTON_SHOW_SEPARATOR = 207,
  HASHTAG = 6,
  HIDDEN_BUTTON_TEXT = 225,
  HIDDEN_CTA_LINK = 227,
  HIDDEN_CTA_TEXT = 226,
  HIDDEN_ICON = 223,
  HIDDEN_TEXT = 224,
  HIDDEN_TITLE = 222,
  IMAGE_DESCRIPTION = 179,
  IMAGE_URL = 5,
  INCLUDED_ITEMS_LIST_DESCRIPTION = 194,
  INCLUDED_ITEM_ICON = 195,
  IN_PROGRESS = 16,
  JOB = 28,
  LINKED_CHALLENGES_DESCRIPTION = 81,
  LINKED_CHALLENGE_ID = 83,
  LINKED_CHALLENGE_TYPE = 82,
  LOCATION = 22,
  MAIL = 51,
  MAPS_URL = 49,
  MATERIAL_BRAND = 52,
  MATERIAL_CONTENT = 55,
  MATERIAL_DESCRIPTION = 54,
  MATERIAL_IMAGE = 56,
  MATERIAL_ORDER = 53,
  MATERIAL_TYPE = 79,
  MENTION = 7,
  NOTIFICATION_RECIPIENT = 143,
  ONLINE = 17,
  PEARL_CONDITIONS = 158,
  PRE_INSCRIPTION_TEXT = 37,
  PRE_PARTICIPATION_TEXT = 38,
  QUESTION_DESCRIPTION = 178,
  QUESTION_IMAGE_URL = 12,
  QUESTION_JUSTIFICATION = 40,
  QUESTION_SHOW_STATISTICS = 136,
  QUESTION_TYPE = 135,
  QUIZ_CONTENT = 10,
  QUIZ_IMAGE = 57,
  QUIZ_POINTS_LABEL = 91,
  QUIZ_TYPEFORM_BUTTON_TEXT = 105,
  QUIZ_TYPEFORM_DESCRIPTION = 199,
  QUIZ_TYPEFORM_IMAGE = 200,
  QUIZ_TYPEFORM_TITLE = 198,
  QUIZ_TYPEFORM_TYPEFORM_ID = 106,
  QUIZ_TYPEFORM_VIDEO = 201,
  QUIZ_VIDEO_URL = 11,
  QUIZ_DERMO_TITLE = 247,
  QUIZ_DERMO_DESCRIPTION = 243,
  QUIZ_DERMO_VIDEO = 244,
  REDEEM_PRODUCT_BUTTON = 90,
  REDEEM_PRODUCT_DESCRIPTION = 167,
  REDEEM_PRODUCT_TERMS_LINK = 130,
  REDEEM_PRODUCT_TERMS_TEXT = 154,
  REMINDER_CONTENT = 26,
  REMINDER_TIME = 27,
  RESOURCE_GUIDE_DESCRIPTION = 75,
  RESOURCE_GUIDE_SCORE = 86,
  RETRY = 8,
  SELL_IN_CONDITIONS = 145,
  SELL_IN_DESCRIPTION = 144,
  SELL_IN_IMAGE_RANGES = 150,
  SELL_IN_IMAGE_RANGES_MIN_QUANTITY = 152,
  SELL_IN_PRODUCT_DEFAULT_ITEMS = 149,
  SELL_IN_PRODUCT_ID = 146,
  SELL_IN_PRODUCT_MAX_ITEMS = 147,
  SELL_IN_PRODUCT_MIN_ITEMS = 148,
  SELL_IN_PRODUCT_MIN_QUANTITY = 153,
  SELL_OUT_BODY_DESCRIPTION = 121,
  SELL_OUT_BODY_END_DATE = 122,
  SELL_OUT_BODY_MAIN_IMAGE = 124,
  SELL_OUT_BODY_START_DATE = 123,
  SELL_OUT_BODY_TITLE = 120,
  SELL_OUT_DESCRIPTION = 119,
  SELL_OUT_DESCRIPTION_LARGE = 125,
  SELL_OUT_POINTS_RANGE_MAX = 128,
  SELL_OUT_POINTS_RANGE_MIN = 129,
  SELL_OUT_REPORT_FILE_TYPE = 126,
  SELL_OUT_REPORT_QUANTITY = 127,
  SHOPPING_CART_BUTTON_TEXT = 65,
  SHOPPING_CART_CONDITIONS = 64,
  SHOPPING_CART_DESCRIPTION = 63,
  SHOPPING_CART_GROUP_DESCRIPTION = 68,
  SHOPPING_CART_GROUP_MAX_ITEMS = 69,
  SHOPPING_CART_GROUP_MIN_ITEMS = 70,
  SHOPPING_CART_MAX_ITEMS = 66,
  SHOPPING_CART_MIN_ITEMS = 67,
  SHOPPING_CART_PRODUCT_DEFAULT_ITEMS = 74,
  SHOPPING_CART_PRODUCT_ID = 71,
  SHOPPING_CART_PRODUCT_MAX_ITEMS = 72,
  SHOPPING_CART_PRODUCT_MIN_ITEMS = 73,
  SHOPPING_CART_SHOW_PRICES = 159,
  SHOW_STATISTICS = 39,
  SPEAKER_EMAIL = 47,
  SPEAKER_IMAGE = 46,
  SPEAKER_JOB = 28,
  SPEAKER_NAME = 36,
  SPEAKER_PHONE = 48,
  STEPS_CARD_CONTENT = 133,
  STEPS_CARD_IMAGE = 134,
  STEPS_CARD_IMAGE_DESKTOP = 139,
  STEPS_CARD_LINK = 160,
  STEPS_CARD_NAME = 140,
  STEPS_CARD_SHOW_NUMBERS = 132,
  STEPS_CARD_TEXT_LINK = 161,
  STEPS_DESCRIPTION = 131,
  SURVEY_BUTTON_TEXT = 84,
  SURVEY_DATE = 59,
  SURVEY_DESCRIPTION = 62,
  SURVEY_END_DATE = 85,
  SURVEY_END_TEXT = 95,
  SURVEY_ID = 58,
  TEXT_BODY = 1,
  TEXT_DESKTOP_IMAGE = 92,
  TEXT_DURATION_CONTENT = 196,
  TEXT_DURATION_ICON = 197,
  TEXT_IMAGE_POSITION = 94,
  TEXT_LINK_LINK = 172,
  TEXT_LINK_TEXT = 173,
  TEXT_MOBILE_IMAGE = 93,
  TIME_TO_SHOW_LINK = 137,
  URL = 23,
  USER_UPLOAD_MEDIA_ALLOWED_EXTENSIONS = 111,
  USER_UPLOAD_MEDIA_BUTTON_TITLE = 110,
  USER_UPLOAD_MEDIA_DESCRIPTION = 109,
  USER_UPLOAD_MEDIA_LINK_STATIC_PAGES = 112,
  VIDEO_BUTTON = 138,
  VIDEO_DESCRIPTION = 77,
  VIDEO_OPTIONAL_IMAGE = 78,
  VIDEO_SECTION_DESCRIPTION = 174,
  VIDEO_SECTION_DESKTOP_IMAGE = 164,
  VIDEO_SECTION_ID = 162,
  VIDEO_SECTION_MOBILE_IMAGE = 165,
  VIDEO_SECTION_TYPE = 163,
  VIDEO_ASPECT_RATIO = 307,
  VIDEO_URL = 4,
  WATCH_AGAIN_ONLY_ATTENDED_USERS = 61,
  WATCH_AGAIN_YT_ID = 60,
  WYSIWYG_DETAIL = 157,
  WYSWYG_CONTENT = 190,
  WYSWYG_DESCRIPTION = 189,
  UPLOAD_MEDIA_NEW = 300,
  TEXT_DESCRIPTION_LINK = 334,
  TEXT_URL_LINK = 335,
  WEBEAT_CHECKOUT_PRODUCT_COPAY = 338,
  WEBEAT_CHECKOUT_PRODUCT_PRICE = 339,
}

export enum DetailsTypesEnum {
  BOOLEAN = 'boolean',
  DATE = 'timestamp',
  NUMBER = 'number',
  TEXT = 'text',
  TEXT_AREA = 'textarea',
  TIME = 'time',
  UPLOAD = 'upload',
  URL = 'url',
}

export const isTextDetail = (type: string | number) => {
  if (type === DetailsTypesEnum.TEXT || type === DetailsTypesEnum.TEXT_AREA)
    return true;
  else return false;
};

export const isBooleanDetail = (type: string | number) => {
  if (type === DetailsTypesEnum.BOOLEAN) return true;
  else return false;
};
